export const merchantOnboardingShellClass =
  'font-sans text-merchant-ink antialiased'

export const merchantRegistrationFieldClass =
  'w-full rounded border border-merchant-field-border bg-white px-4 py-[15px] text-base text-merchant-ink outline-none transition-colors placeholder:text-merchant-placeholder focus:border-merchant-primary focus:ring-2 focus:ring-merchant-primary/10'

export const merchantRegistrationPasswordFieldClass =
  'w-full rounded-lg border border-transparent bg-white px-4 py-[15px] text-sm text-merchant-ink shadow-[0px_0px_0px_1px_rgba(198,196,218,0.3)] outline-none transition-colors placeholder:text-[#6B7280] focus:ring-2 focus:ring-merchant-primary/10'

/** Mobile location step (Figma 715:915): filled inputs, no visible border */
export const merchantRegistrationFieldBareClass =
  'border-transparent focus:border-merchant-primary/25 focus:ring-2 focus:ring-merchant-primary/10'

export const merchantRegistrationLabelClass =
  'text-xs font-normal uppercase tracking-[0.06em] text-merchant-muted'

export const merchantRegistrationPasswordLabelClass =
  'text-[10px] font-bold uppercase tracking-[0.05em] text-merchant-body'
